import { useTranslation } from 'react-i18next';

interface ErrorTypes {
  title: string;
  name: string;
  description: string;
}

export default function ErrorPage({ title, name, description }: ErrorTypes) {
  const { t } = useTranslation();

  return (
    <main className="grid gap-4 w-700 mx-auto">
      <h1 className="text-hero font-bold">{name}</h1>
      <h2 className="text-hero font-bold">{t(`${title}`)}</h2>
      <span>{t(`${description}`)}</span>
    </main>
  );
}
